import { useEffect } from 'react';

import { useCustomRouter } from '@/hooks/useCustomRouter';

import type { FlutterInAppWebViewWindow } from '../_utils/window-types';

export const useAppBack = () => {
  const { back } = useCustomRouter();

  useEffect(() => {
    const _window = window as FlutterInAppWebViewWindow;

    if (_window.router) {
      _window.router.back = () => back();
    }
  }, [back]);
};
